import React from 'react'
import { Empty, Image, Typography } from 'antd'
import CustomButton from '../CustomButton/Button';
import ArrowRightIcon from "../../assets/icons/arrow-right-blue.svg"
import { useNavigate } from 'react-router-dom';
import './NoData.scss'

const { Text } = Typography;

const NoData = ({ desc, btnText }) => {
    const navigate = useNavigate();

    return (
        <div className="empty-container">
            <Empty
                description={
                    <Text>{desc ? desc : "No Data"}</Text>
                }
            >
                {btnText ?
                    <CustomButton
                        size="small"
                        variant="text"
                        color="primary"
                        icon={<Image src={ArrowRightIcon} alt='Arrow Right' preview={false} />}
                        iconPosition="end"
                        onClick={() => navigate('/profile', { state: { value: "bank" } })}
                    >
                        {btnText}
                    </CustomButton>
                    : null}
            </Empty>
        </div>
    )
}

export default NoData